import React from 'react'
import './index.scss'
import { NavLink } from 'react-router-dom'
import axios from 'axios'
import { Input, message } from 'antd'
import {url} from "../../utils";

export default class ContactForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      contactName: '',
      contactEmail: '',
      contactSubject: '',
      contactMessage: ''
    }
  }
  sendBtn () {
    if (this.state.contactName === ''){
      message.error('Your Name 不能为空');
    } else if (this.state.contactEmail === '') {
      message.error('Your Email 不能为空');
    }else {
      axios({
        method:'post',
        url:`${url}/insertcontactuser`,
        data: {
          contactName: this.state.contactName,
          contactEmail: this.state.contactEmail,
          contactSubject: this.state.contactSubject,
          contactMessage: this.state.contactMessage
        }
      }).then(({data}) => {
        if (data.code === 0) {
          message.success('send success');
          setTimeout(()=>{
            this.setState({
              contactName: '',
              contactEmail: '',
              contactSubject: '',
              contactMessage: ''
            })
          },2000)
        }
      })
    }
  }
  inputName (e) {
    this.setState({
      contactName: e.target.value
    })
  }
  inputEmail (e) {
    this.setState({
      contactEmail: e.target.value
    })
  }
  inputSubject(e) {
    this.setState({
      contactSubject: e.target.value
    })
  }
  inputMessage (e) {
    this.setState({
      contactMessage: e.target.value
    })
  }
	render() {
		return(
			<div className="contact_form">
        <section  className="contact_content">
           <aside className="aside_img">
               <img alt="" src={require('../../assets/img/contact/banner.png')}/>
           </aside>
           <section className="bg-nex" style={{backgroundImage: `url(${require('../../assets/img/contact/lianxi.png')})`}}>
               <section className="bg-nex-word"> Contact from <i>&gt;&gt;</i></section>
           </section>
           <section className="abz-word">
             <NavLink to="/" style={{marginRight:'5px',marginLeft:'5px'}}>Abzed</NavLink>>
             <NavLink to="/main/contact/from" style={{marginLeft:'5px'}}>Contact</NavLink>
           </section>
        </section>
        <hr/>
        <section  className="touch_content">
          <section style={{marginTop:'0.17rem'}}><span>Your Name(required)</span><Input onChange={this.inputName.bind(this)} value={this.state.contactName} type="text"/></section>
          <section><span>Your Email(required)</span><Input onChange={this.inputEmail.bind(this)} value={this.state.contactEmail} type="text"/></section>
          <section><span>Subject</span><Input onChange={this.inputSubject.bind(this)} value={this.state.contactSubject} type="text"/></section>
          <section><span style={{height:'74px',lineHeight:'74px'}}>Your Message</span><Input onChange={this.inputMessage.bind(this)} value={this.state.contactMessage} type="textarea" style={{height:'74px'}}/></section>
          <section>
            <button onClick={this.sendBtn.bind(this)}>Send</button>
          </section>
        </section>
      </div>
    );
	}
}
